import { useMemo } from 'react';
import { EventFilter, EventSort } from '@/features/BrowseBar';
import type { EventsBrowseBarConfig } from '@/features/BrowseBar';
import { SortOption } from '@/utils/query-filters';
import { SourceType } from '@/types/source';

const BASE_EVENTS_CONFIG: EventsBrowseBarConfig = {
    filters: [
        EventFilter.DATE_RANGE,
        EventFilter.SOURCE,
        EventFilter.OBJECT_TYPE,
    ],
    sorts: [EventSort.DATE],
};

interface EventsBrowseConfigInput {
    eventId: string | undefined;
    sourceCount: number;
    source: { type: SourceType } | undefined;
}

export function useEventsBrowseConfig({
    eventId,
    sourceCount,
    source,
}: EventsBrowseConfigInput) {
    const defaultSortOption = useMemo(() => {
        if (eventId) {
            return SortOption.CONFIDENCE;
        }
        if (sourceCount > 0 && source) {
            return source.type === SourceType.FILE
                ? SortOption.DATE_OLDEST
                : SortOption.DATE_NEWEST;
        }
        return SortOption.DATE_NEWEST;
    }, [eventId, sourceCount, source]);

    const eventsConfig = useMemo<EventsBrowseBarConfig>(() => {
        if (eventId) {
            return {
                ...BASE_EVENTS_CONFIG,
                sorts: [EventSort.DATE, EventSort.CONFIDENCE],
            };
        }
        return BASE_EVENTS_CONFIG;
    }, [eventId]);

    return { defaultSortOption, eventsConfig };
}
